import React from 'react';
import { motion } from 'framer-motion';
import { ArrowRightIcon, DownloadIcon, EuroIcon, FileTextIcon, LanguagesIcon, MailIcon } from 'lucide-react';
import { CTAButton } from './Shared';
import { Bellflower, Blossom, Daisy, DropperBottle, FlowerSpike, Sprig } from './FloralDecor';
const assurances = [{
  icon: DownloadIcon,
  text: 'Formato digitale'
}, {
  icon: FileTextIcon,
  text: '100% PDF'
}, {
  icon: LanguagesIcon,
  text: 'Interamente in italiano'
}, {
  icon: EuroIcon,
  text: 'Prezzo in euro'
}, {
  icon: MailIcon,
  text: 'Assistenza via email'
}];
const productImage = 'https://cdn.magicpatterns.com/uploads/6gR3M45KrWU7rc7Q17t5E1/Mockup_italiano_floral_con_sello_dorado.png';
export function Hero() {
  return <header className="relative overflow-hidden border-b border-stone-200 bg-amber-50/60 pb-10 pt-5 text-stone-900 md:pb-16 md:pt-8 lg:pt-10" data-id="element-169" data-mp="nbf0tnkykx0x">
      <div aria-hidden="true" className="pointer-events-none absolute inset-0 overflow-hidden" data-id="element-170" data-mp="382fedm0930dv">
        <Sprig className="absolute -left-6 top-6 h-72 w-44 text-emerald-700/15 md:h-96 md:w-56" data-id="element-171" data-mp="3j8iyr3vxcowt" />
        <Sprig className="absolute -right-8 top-24 h-72 w-44 -scale-x-100 text-emerald-700/10 md:h-[26rem] md:w-56" data-id="element-172" data-mp="3o7lshs6gf8ph" />
        <Blossom className="absolute left-[3%] top-[58%] h-14 w-14 md:h-20 md:w-20" petalClassName="text-pink-300/70" centerClassName="text-amber-400" data-id="element-173" data-mp="39al7s8moke0i" />
        <Daisy className="absolute right-[4%] top-[6%] h-12 w-12 md:h-16 md:w-16" petalClassName="text-amber-100" centerClassName="text-amber-400" data-id="element-174" data-mp="3e7l6fyh7aehl" />
        <FlowerSpike className="absolute -bottom-4 left-[42%] hidden h-40 w-12 lg:block" petalClassName="text-violet-300/60" centerClassName="text-emerald-600/40" data-id="element-175" data-mp="3599ik47pxusu" />
        <Bellflower className="absolute bottom-0 right-[2%] hidden h-44 w-24 md:block" petalClassName="text-violet-300/60" centerClassName="text-emerald-600/40" data-id="element-176" data-mp="2qhqx3qw3b823" />
        <Daisy className="absolute bottom-8 left-[18%] hidden h-10 w-10 lg:block" petalClassName="text-rose-200" centerClassName="text-orange-300" data-id="element-177" data-mp="2hkgipwnz72sy" />
        <DropperBottle className="absolute bottom-6 left-[5%] hidden h-32 w-16 text-amber-700/15 lg:block" data-id="element-178" data-mp="s21gc6a6u3xc" />
      </div>

      <div className="relative mx-auto max-w-7xl px-4 text-center sm:px-6 lg:px-8 lg:text-left" data-id="element-179" data-mp="nat6j94y4gjn">
        <motion.div initial={{
        opacity: 0,
        y: 18
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.3,
        ease: [0.23, 1, 0.32, 1]
      }} className="grid items-center lg:grid-cols-[1.05fr_1fr] lg:gap-x-12" data-id="element-180" data-mp="ibp18tl572yl">
          <div className="lg:col-start-1 lg:row-start-1 lg:self-end" data-id="element-181" data-mp="161t3awiomunh">
            <p className="mb-3 text-xs font-semibold tracking-widest text-amber-800 md:text-sm" data-id="element-182" data-mp="162lzx4nxg3rw">LUMEN AKASHA™</p>
            <h1 className="text-3xl font-bold leading-tight tracking-tight text-emerald-900 md:text-5xl lg:text-6xl lg:leading-none lg:tracking-tighter" data-id="element-183" data-mp="114svag29vhtq">
              Consulenze più chiare, più approfondite <span className="text-rose-700" data-id="element-184" data-mp="3lqudvm65c340">e senza improvvisare.</span>
            </h1>
            <p className="mx-auto mt-4 max-w-2xl text-sm leading-relaxed text-stone-700 md:mt-5 md:text-lg lg:mx-0" data-id="element-185" data-mp="3hq26kygu48ad">
              Le conoscenze le hai già. Il metodo per organizzare ogni incontro, spiegare le tue scelte e dare
              continuità al percorso, ora anche.
            </p>
            
          </div>

          <div className="mt-6 flex justify-center md:mt-8 lg:col-start-2 lg:row-span-2 lg:row-start-1 lg:mt-0" data-id="element-186" data-mp="26868q58azxc6">
            <motion.img src={productImage} alt="Kit Completo Fiori di Bach in formato digitale: Tomo I, Tomo II, cinque bonus e la Mappa dei 38 Fiori, con sigillo dorato 2 volumi, 5 bonus + mappa dei 38 fiori" initial={{
            opacity: 0,
            scale: 0.96
          }} animate={{
            opacity: 1,
            scale: 1
          }} transition={{
            duration: 0.3,
            ease: [0.23, 1, 0.32, 1]
          }} className="h-auto w-[92%] max-w-[540px] drop-shadow-2xl" draggable={false} fetchPriority="high" data-id="element-187" data-mp="2g02kgj3bblyv" />
          </div>

          <div className="mt-6 flex flex-col md:mt-8 lg:col-start-1 lg:row-start-2 lg:mt-8 lg:self-start" data-id="element-188" data-mp="zm2kj84gvwbm">
            <div className="order-2 mt-5 lg:order-1 lg:mt-0" data-id="element-189" data-mp="49jem9ab6vo8">
              <h2 className="text-sm font-bold tracking-wide text-emerald-800 md:text-lg" data-id="element-190" data-mp="3vgnhcrzf7vqu">
                KIT COMPLETO FIORI DI BACH™
              </h2>
              <p className="mx-auto mt-1.5 max-w-xl text-sm leading-relaxed text-stone-700 md:text-base lg:mx-0" data-id="element-191" data-mp="e77j3qxpvhjl">
                Una biblioteca pratica di guide, combinazioni da personalizzare e schede di consultazione, da tenere
                accanto al tuo prossimo incontro.
              </p>
            </div>
            <div className="order-1 lg:order-2 lg:mt-6" data-id="element-192" data-mp="3rftu80tsykz0">
              <CTAButton href="#buy" className="w-full gap-2 px-7 py-4 text-sm sm:w-auto md:px-10 md:py-5 md:text-xl" data-id="element-193" data-mp="3rhen7m0gxvur">
                SCOPRI IL KIT
                <ArrowRightIcon className="h-5 w-5" aria-hidden="true" data-id="element-194" data-mp="2yz9au2pbmnih" />
              </CTAButton>
              <p className="mt-2.5 text-xs text-stone-500 md:text-sm" data-id="element-195" data-mp="2u17tpnbggy9n">Pronto da stampare o consultare su tablet.</p>
            </div>
            <ul className="order-3 mt-5 flex flex-wrap items-center justify-center gap-x-5 gap-y-2 border-t border-stone-200 pt-4 text-xs text-stone-700 md:text-sm lg:justify-start" data-id="element-196" data-mp="19hvpcxf8d5ci">
              {assurances.map(({
              icon: Icon,
              text
            }) => <li key={text} className="flex items-center gap-1.5" data-id="element-197" data-mp="14j18i10tpqv1">
                  <Icon className="h-4 w-4 shrink-0 text-rose-600" aria-hidden="true" data-id="element-198" data-mp="14h7w053j4cf4" />
                  <span data-id="element-199" data-mp="1s728umnum0zd">{text}</span>
                </li>)}
            </ul>
          </div>
        </motion.div>
      </div>
    </header>;
}